import { Checkbox, FormControl, FormErrorMessage, FormLabel, Link } from "@chakra-ui/react";
import { forwardRef, ReactNode, SyntheticEvent, useImperativeHandle, useState } from "react";
import RequiredMark from "./RequiredMark";

interface InputCheckboxProps {
    label: string;
    text?: string;
    input?: ReactNode;
    isRequired: boolean;
    initValue?: boolean;
}

const InputCheckbox = forwardRef((props: InputCheckboxProps, ref) => {

    const [value, setValue] = useState<boolean>(props.initValue ?? false);
    const [textError, setTextError] = useState<string>("");

    const validateValue = () => {
        if (props.isRequired && !value) {
            setTextError(`${props.label} jest wymagane`);
            return false;
        } else {
            setTextError("");
            return true;
        }
    };

    useImperativeHandle(ref, () => ({
        validate: () => validateValue(),
        value() { return value; }
    }));

    const handleSubmit = (e: SyntheticEvent) => {
        const input = e.currentTarget as HTMLInputElement;
        setValue(input.checked);
    };
  
    return (
        <FormControl isInvalid={!!textError}
            mt="5"
        >
            <FormLabel>{props.label} {props.isRequired && <RequiredMark />}</FormLabel>
                <Checkbox
                    type="text"
                    checked={value}
                    onChange={(e) => handleSubmit(e)}
                    onBlur={validateValue}
                />
                {props.text != null ? props.text : props.input}
            <FormErrorMessage>{textError}</FormErrorMessage>
        </FormControl>
    );
  });

  export default InputCheckbox;